import {Component, OnInit} from '@angular/core';
import {SimpleSavedQueryResource} from '../../../shared/models/resources/simpleSavedQueryResource.model';
import {CONFIG} from '../../../config';
import {GlobalIntegrationService} from '../../../shared/services/globalIntegration.service';
import {AuthenticationService} from '../../../core/services/authentication.service';
import {CoreService} from '../../../core/data-services/core.service';
import {BannerNotificationsService, SpinnerService} from '../../../xform-compat';
import {TranslateService} from '@ngx-translate/core';
import {SimpleEventsEmailResource} from '../../../shared/models/resources/simpleEventsEmailResource.model';
import {JqueryCommonService} from '../../../shared/services/jquery-common.service';
import {JqueryDialogOptions} from '../../../shared/models/jqueryDialogOptions.model';

@Component({
  standalone: false,
    selector: 'cci-saved-queries-panel',
    templateUrl: './saved-queries-panel.component.html',
    styleUrls: ['./saved-queries-panel.component.scss']
})
export class SavedQueriesPanelComponent implements OnInit {

    public maxSavedQueries = 5;
    public results: SimpleSavedQueryResource[] = [];

    public saveModalNickname: string;
    public deleteModalNickname: string;

    constructor(
        private globalIntegrationService: GlobalIntegrationService,
        private authenticationService: AuthenticationService,
        private bannerNotificationsService: BannerNotificationsService,
        private spinnerService: SpinnerService,
        private translateService: TranslateService,
        private jqueryCommonService: JqueryCommonService,
        private coreService: CoreService,
    ) {
    }

    public static pop(list: any[], index: number) {
        return list.slice(0, index).concat(list.slice(index + 1, list.length));
    }

    ngOnInit() {
        this.getAll();
        this.initEventsQuerySaveEventEmitter();
        this.initEmailPanelResponseEventEmitterSubscriptions();
    }

    public initEventsQuerySaveEventEmitter() {
        this.globalIntegrationService.eventsQuerySaveEventEmitter.subscribe((event) => {
            console.warn('saved-query-panel eventsQuerySaveEventEmitter: ', event);
            this.globalIntegrationService.emailPanelRequestEventEmitter.next(event);
        });
    }

    public initEmailPanelResponseEventEmitterSubscriptions() {
        this.globalIntegrationService.emailPanelResponseEventEmitter.subscribe((event) => {

            if (this.results !== null && this.results.length >= this.maxSavedQueries) {
                this.bannerNotificationsService.error('You are limited to ' + this.maxSavedQueries + ' saved queries -- please delete some first.');
                return;
            }

            const eventsEmailResource = (event as SimpleEventsEmailResource);
            const savedQueryResource = new SimpleSavedQueryResource({
                nickname: 'DEFAULT',
                eventsEmailResource: eventsEmailResource,
            });
            console.warn(savedQueryResource);

            this.saveModal(savedQueryResource);
        });
    }

    public load(index: number) {
        console.warn('saved-queries: load', index);
        const savedQuery = this.results[index];
        this.globalIntegrationService.savedQueryLoadEventEmitter.next(savedQuery.eventsEmailResource);
        this.bannerNotificationsService.success('Loaded saved query: ' + savedQuery.nickname);
    }

    public rename(index: number) {
        console.warn('saved-queries: rename', index);
    }

    public saveModal(newResource: SimpleSavedQueryResource) {
        const that = this;
        console.warn('saved-queries: saveModal', newResource);

        this.saveModalNickname = '';
        const dialog = this.jqueryCommonService.dialog('cci-saved-queries-save-modal'.toClass(), new JqueryDialogOptions({
            autoOpen: false,
            resizable: false,
            dialogClass: null,
            open: null,
            height: null,
            width: null,

            modal: true,
            buttons: [{
                text: 'Save',
                click: function (e) {
                    that.save(newResource);
                    dialog.dialog('close');
                }
            },
                {text: 'Cancel', click: () => dialog.dialog('close')}],
            close: function () {
            }
        }));
    }

    public save(newResource: SimpleSavedQueryResource) {
        newResource.nickname = this.saveModalNickname;
        const newResults = this.cloneRecords().concat(newResource);
        this.putAll(newResults);
    }

    public deleteModal(index: number) {
        const that = this;
        console.warn('saved-queries: deleteModal', index);

        this.deleteModalNickname = this.results[index].nickname;
        const dialog = this.jqueryCommonService.dialog('cci-saved-queries-delete-modal'.toClass(), new JqueryDialogOptions({
            autoOpen: false,
            resizable: false,
            dialogClass: null,
            open: null,
            height: null,
            width: null,

            modal: true,
            buttons: [{
                text: 'Delete',
                click: function (e) {
                    that.delete(index);
                    dialog.dialog('close');
                }
            },
                {text: 'Cancel', click: () => dialog.dialog('close')}],
            close: function () {
            }
        }));
    }

    public delete(index: number) {
        console.warn('saved-queries: delete', index);
        const newResults = SavedQueriesPanelComponent.pop(this.cloneRecords(), index);
        this.putAll(newResults);
    }

    public cloneRecords() {
        const newResults = [];
        for (const index in this.results) {
            const result = this.results[index];
            newResults.push(new SimpleSavedQueryResource(result));
        }
        return newResults;
    }

    public updateRecords(records: SimpleSavedQueryResource[]) {
        this.results = [];
        for (const index in records) {
            const result = records[index];
            const resource = new SimpleSavedQueryResource(result as any);
            this.results.push(resource);
        }
    }

    public getAll() {
        console.warn('saved queries panel load');
        this.spinnerService.start();
        this.coreService.getSavedQueries().subscribe((results) => {
            this.spinnerService.stop();
            this.updateRecords((results as SimpleSavedQueryResource[]));
        }, (response) => {
            this.spinnerService.stop();
            console.error(response);
            const errorCode = (response && response.error) ? response.error.code : CONFIG.authErrorCode;
            this.bannerNotificationsService.error(this.translateService.instant(`API_ERRORS.${errorCode}`));
        });
    }

    public putAll(savedQueryResources: SimpleSavedQueryResource[]) {
        this.spinnerService.start();
        this.coreService.postSavedQueries(savedQueryResources).subscribe((results) => {
            this.spinnerService.stop();
            this.updateRecords((results as SimpleSavedQueryResource[]));
            this.bannerNotificationsService.success('Saved queries have been updated.');
        }, (response) => {
            this.spinnerService.stop();
            console.error(response);
            const errorCode = (response && response.error) ? response.error.code : CONFIG.authErrorCode;
            this.bannerNotificationsService.error(this.translateService.instant(`API_ERRORS.${errorCode}`));
        });
    }

    public toJson(e: any) {
        return JSON.stringify(e);
    }

}
